<template>
  <div id="app">
    <navigation></navigation>
    <alert :type="alert.type" :msg="alert.msg"></alert>
    <div class="content">
      <router-view/>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import Alert from '@/components/shared/Alert';
import Navigation from '@/components/shared/Navigation';
import FooterNav from '@/components/shared/FooterNav';

export default {
  components: { Alert, Navigation, FooterNav },
  name: 'app',
  metaInfo: {
    title: 'Birthday',
    titleTemplate: '%s | MightyGift',
    link: [
      { rel: 'icon', type: 'image/x-icon', href: '/static/favicon.ico' },
    ],
  },
  computed: {
    alert() {
      return this.$store.state.alert.alert;
    },
  },
};
</script>

<style src="./assets/scss/index.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue